<ng-container *ngIf="isOngoing && isToday">
  <span>Today {{ start | date: 'HH:mm' }} - ongoing</span>
</ng-container>

<ng-container *ngIf="isOngoing && !isToday">
  <span>{{ start | date: 'dd/MM/yy HH:mm' }} - ongoing</span>
</ng-container>


<ng-container *ngIf="!isOngoing && isToday && isSameDay">
  <span>Today {{ start | date: 'HH:mm' }} - {{ end | date: 'HH:mm'}}</span>
</ng-container>


<ng-container *ngIf="!isOngoing && isToday && !isSameDay">
  <span>{{ start | date: 'dd/MM/yy HH:mm' }} - Today {{ end | date: 'HH:mm'}}</span>
</ng-container>


<ng-container *ngIf="!isOngoing && !isToday && isSameDay">
  <span>{{ start | date: 'dd/MM/yy HH:mm' }} - {{ end | date: 'HH:mm'}}</span>
</ng-container>


<ng-container *ngIf="!isOngoing && !isToday && !isSameDay">
  <span>{{ start | date: 'dd/MM/yy HH:mm' }} - {{ end | date: 'dd/MM/yy HH:mm'}}</span>
</ng-container>
